// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pd-0";